import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {selectOrganizationTemplates} from "../../../../app/store/reducers/excel/excelReducer";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {TYPE_ITEMS} from "../../../../enum/ExcelTemplateTypes";
import {exportBulkItemsAsync} from "../../../../app/store/reducers/item/itemReducer";
import {Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {downloadFile} from "../../../../helpers/excel-uploader";
import PropTypes from "prop-types";

const UploadBulkItemsToExcel = ({selectedItems}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const organizationTemplates = useSelector(selectOrganizationTemplates);

    const [itemTypeTemplates, setItemTypeTemplates] = useState([]);
    useEffect(() => {
        const templates = organizationTemplates.filter(template => template.type === TYPE_ITEMS) || [];
        setItemTypeTemplates(templates);
    }, [organizationTemplates])


    const [loading, setLoading] = useState(false);
    const exportItems = (uri) => {
        setLoading(true);
        exportBulkItemsAsync(uri, {ids: selectedItems.map(({item}) => item.id)})
            .then(({content, contentType}) => {
                downloadFile({
                    content: content,
                    contentType: contentType,
                    fileName: t(lang, 'items.table.title'),
                });
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            })
    }


    return (
        <Dropdown className="m-1">
            <Dropdown.Toggle bsPrefix="toggle"
                             variant="falcon-default"
                             size="sm"
                             disabled={loading}
            >
                {loading
                    ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                    : <FontAwesomeIcon className="me-1" icon={faFileExcel}/>
                }
                {t(lang, 'items.common.download')}
            </Dropdown.Toggle>
            <Dropdown.Menu className='py-2'>
                {itemTypeTemplates.map((template, index) => {
                    return (
                        <Dropdown.Item as="button" key={index} onClick={() => exportItems(template.uri)}>
                            {t(lang, 'main.common.file.upload.template_name.prefix', {template_name: t(lang, `common.excel.template.name.${template.name}`)})}
                        </Dropdown.Item>
                    )
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default UploadBulkItemsToExcel;

UploadBulkItemsToExcel.propTypes = {
    selectedItems: PropTypes.array
};

UploadBulkItemsToExcel.defaultProps = {
    selectedItems: []
};